/**
 * Global game rankings by bet volume (from ClickHouse)
 * Period: March 2026
 */
const GAME_RANKINGS = {
  'lucky-caramelo-2': 1,
  'prosperity-rabbit': 2,
  'swaggy-caramelo': 3,
  'firecrackers-fortune': 4,
  'lucky-caramelo-1000': 5,
  'swaggy-caramelo-super': 6,
  'prosperity-ox': 7,
  'firecrackers-fortune-100': 8,
  'year-of-the-golden-horse': 9,
  'prosperity-dragon': 10,
  'prosperity-tiger': 11,
  'fortune-pig': 12,
  'shapes-of-fortune': 13,
  'prosperity-horse': 14,
  'capricorns-orb-of-fortune': 15,
  'lucky-panda': 16,
  'the-lucky-year': 17,
  'shapes-of-fortune-xmas': 18,
  'prosperity-mouse': 19,
  'aquarius-fortune-wheel': 20,
  'prosperity-clash': 21,
  'wheel-of-wealth': 22,
  'money-mania': 23,
  'lucky-fox': 24,
  'mines': 25,
  'pirates-treasure-reel': 26,
  'prosperity-dragon-golden-reel': 27,
  'smash-fury': 28,
  'blackjack': 29,
  'pisces-realm-of-fortune': 30,
  'lucky-snake': 31,
  'fiesta-blue': 32,
  'lucky-turtle': 33,
  'fiesta-green': 34,
  'iron-valor': 35,
  'lucky-duck': 36,
  'fiesta-magenta': 37,
  'plinko': 38,
  'realm-of-thunder': 39,
  'fiesta-red': 40,
  'disco-fever': 41,
  'black-assassin': 42,
  'the-lone-fireball': 43,
  'rudolphs-gift': 44,
  'tinkering-box': 45,
  'aztecs-mystery': 46,
  'farmageddon': 47,
  'gold-diggers': 48,
  'wheel': 49,
  'battleship': 50,
  'eggy-pop': 51,
  'coin-flip': 52,
  'treasures-of-hades': 53,
  'inmate-outcuss': 54,
  'dice': 55,
  'magic-circus': 56,
  'golden-koi-trail': 57,
  'limbo': 58,
  'one-wrong-step': 59,
  'semana-santa-treasures': 60,
  'balonismo': 61,
  'diamonds': 62,
  'crash': 63,
  'solar-pong': 64,
  'keno': 65,
  'roulette': 66,
  'chicken-uncrossable': 67,
  'pig-mines': 68,
  'dragon-crash': 69,
  'hilo': 70,
  'coin-race': 71,
  'train': 72,
};

export default GAME_RANKINGS;
